import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Agent from "./pages/Agent";
import Users from "./pages/Users";
import About from "./pages/About";
import JoinUs from "./pages/Join";
import { Signup } from "./pages/Signup";
import { Signin } from "./pages/Signin";
import Dashboard from "./pages/app";
import SendPackage from "./pages/app/send-package";
import NotFound from "./pages/NotFound";
import PrivateRoute from "./components/app/PrivateRoute";
import Profile from "./pages/app/profile";
import ConnectedCards from "./pages/app/connected-cards";
import DeliveryDetails from "./pages/app/delivery-details";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/agent-app" element={<Agent />} />
        <Route path="/users-app" element={<Users />} />
        <Route path="/about" element={<About />} />
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Signin />} />
        {/* <Route element={<PrivateRoute />}> */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/send-package" element={<SendPackage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/connected-cards" element={<ConnectedCards />} />
        <Route path="/delivery-details" element={<DeliveryDetails />} />
        {/* </Route> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
